import React, { ReactNode } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import ReactDOM from "react-dom";
import AppState from "../model/AppState";
import DataUtil from "../util/DataUtil";

type ModalCarrinhoMaioridadeRemoverTodosProps = {
  children?: ReactNode,
  visivel: boolean,
  save: any,
  hide?: any,
};

type ModalCarrinhoMaioridadeRemoverTodosState = {
  enabled: boolean,
};

class ModalCarrinhoMaioridadeRemoverTodos extends React.Component<ModalCarrinhoMaioridadeRemoverTodosProps, ModalCarrinhoMaioridadeRemoverTodosState> {

  constructor(props: ModalCarrinhoMaioridadeRemoverTodosProps) {
    super(props);

    this.saveProdutoAlternativo = this.saveProdutoAlternativo.bind(this);
    this.saveEnabled = this.saveEnabled.bind(this);

    this.state = {
      enabled: false,
    };
  }

  saveProdutoAlternativo(): void {
    const substituir: any = ReactDOM.findDOMNode(this.refs.checkSubstituir);
    const adicionar: any = ReactDOM.findDOMNode(this.refs.checkNaoAdicionar);

    if (substituir.checked) {
      this.props.save(substituir.value);
    }
    if (adicionar.checked) {
      this.props.save(adicionar.value);
    }
  }

  saveEnabled(enabled: boolean): void {
    this.setState({ enabled });
  }

  render(): any {
    let flagInformarMaioridade = true;

    const usuario = AppState.getUsuarioLogado();
    if (usuario) {
      if (DataUtil.getIdade(usuario.nascimento) < 18) {
        flagInformarMaioridade = false;
      }
    }

    return (
      <Dialog open={this.props.visivel}>
        <DialogContent>
          <div className="modal disponivel" id="subs-modal">
            <p className="title">Alguns produtos do seu carrinho só podem ser adquiridos por compradores maiores de idade.  Como deseja proceder ?</p>
            <div className="menu remover">
              <button className="confirmar" onClick={ this.props.save }>Remover todos</button>
              <button onClick={ () => { this.props.hide && this.props.hide(); }}>Remover manualmente</button>
              { flagInformarMaioridade &&
              <button onClick={ () => { AppState.setMaioridade(true); this.props.hide && this.props.hide(); }}>Sou maior de 18 anos</button>
              }
            </div>
          </div>
        </DialogContent>
      </Dialog>
    );
  }
}

export default ModalCarrinhoMaioridadeRemoverTodos;